module.exports = __webpack_public_path__ + "static/img/page3.6767480.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/doudouImg/page3.png
// module id = NpTI
// module chunks = 1